import debug from "debug";

export const core = debug("apply:core");
export const standalone = debug("apply:standalone");
export const embedded = debug("apply:embedded");
